export const ENV = {
    DEV: 'dev',
    SIM: 'sim',
    PRE: 'pre',
    ONLINE: 'online'
};

export const CLUSTER_ENV = {
    MX: 'mx',
    US: 'us'
};
